import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pages/(blog)/blog-details/blog-single-info.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/pages/(blog)/blog-details/more-article.tsx");
